
import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import AboutHeroSection from './components/AboutHeroSection';
import CompanyStorySection from './components/CompanyStorySection';
import ValuesSection from './components/ValuesSection';
import StatsSection from './components/StatsSection';

const About: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <AboutHeroSection />
        <CompanyStorySection />
        <StatsSection />
        <ValuesSection />
      </main>
      <Footer />
    </div>
  );
};

export default About;
